import { useEffect, useRef, useState, useContext } from "react";

import { isEmpty } from "../../../js/common";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import CutControll from "./cutControll";
import DrawControll from "./drawControll";
import TextControll from "./textControll";
import GridControll from "./gridControll";
import { compressImage } from "./convertImage";
import EditorHeader from "bodycodi/cmap/app/components/cmap4010/imageEditors/EditorHeader";

// assets
import undoActive from "bodycodi/cmap/app/img/undo-active.png";
import undoDisable from "bodycodi/cmap/app/img/undo-disable.png";
import redoActive from "bodycodi/cmap/app/img/redo-active.png";
import redoDisable from "bodycodi/cmap/app/img/redo-disable.png";

const ImageEditor = require("tui-image-editor");

export type Point = {
  x: number;
  y: number;
};

export type mask = {
  x: number;
  y: number;
  rotate: number;
  width: number;
  height: number;
  ref: string;
  image: boolean;
  fontSize?: number;
  fontFamily?: string;
  color?: string;
  active?: boolean;
  lineHeight?: number;
};

export type ColorPicker = {
  color: string;
  setColor: Function;
  editor: any;
  activeObject: any;
  setMode1: Function;
};

export type DrawProp = {
  color: string;
  setColor: Function;
  editor: any;
  activeObject: any;
  activeObjectText: any;
  setMode1: Function;
  brush: number;
  setBrush: Function;
  setActiveObject: Function;
  setActiveObjectText: Function;
};

type ImageEditerProp = {
  file: any;
  setEditor: any;
  editor: any;
  returnUrl: Function;
  handleClose: any;
  src: any;
};

type FunctionsProp = {
  editor: any;
  activeObject: any;
  activeObjectText: any;
  setActiveObject: Function;
  setActiveObjectText: Function;
  path: any;
  editorDiv: any;
  mode: string;
  setMode: Function;
  loadImage: boolean;
  setLoadImage: Function;
};

export type CutFunctionsProp = {
  editor: any;
  setMode: Function;
};

export type GridFunctionsProp = {
  editor: any;
  setMode: Function;
  activeGrid: string;
  setActiveGrid: Function;
  path: any;
  mode1: string;
  setMode1: Function;
  multiple: number;
  setMultiple: Function;
  editorDiv: any;
  setLoadImage: Function;
};

type ControllerProp = {
  editor: any;
  undo: boolean;
  redo: boolean;
  editorDiv: any;
};

export const colorList = [
  "#FFFFFF",
  "#000000",
  "#B0B0B0",
  "#F95D57",
  "#FEBA50",
  "#FFE554",
  "#6BFE7E",
  "#4AA7FD",
  "#B53DFF",
  "#FF92CA",
  "#9E6647",
  "#FACEB3",
];

export const brushList = [12, 20, 30, 40];

export const sizeList = [{ fontSize: 14 }, { fontSize: 24 }, { fontSize: 38 }, { fontSize: 48 }];

export const convertOrigin = (i: number) => {
  let x = Math.floor(Math.cos(degreesToRadians(i * 30)) * 20);
  let y = Math.floor(Math.sin(degreesToRadians(i * 30)) * 20);
  return { x, y };
};

export function degreesToRadians(degrees: number) {
  const pi = Math.PI;
  return degrees * (pi / 180);
}

export function hexToRgba(hex: string, a: number) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
        a: a,
      }
    : null;
}

export const calcSize = (image: any, editor: any) => {
  const maxWidth = editor.getCanvasSize().width * 1;
  const maxHeight = editor.getCanvasSize().height * 1;
  let width = image.width * 1;
  let height = image.height * 1;
  let size = { width: width, height: height };
  if (maxWidth > maxHeight) {
    let width1 = Math.floor(maxWidth);
    let height1 = height * (maxWidth / width);
    size = { width: width1, height: height1 };
  } else {
    /*let height2 = Math.floor(maxHeight);
        let width2 = width*(maxHeight/height);
        size = {width: width2, height: height2};*/
    let width1 = Math.floor(maxWidth);
    let height1 = height * (maxWidth / width);
    size = { width: width1, height: height1 };
  }
  return size;
};

const ImageEditer = ({ file, setEditor, editor, returnUrl, handleClose, src }: ImageEditerProp) => {
  const { dispatch } = useContext(DispatchContext);
  const editorDiv = useRef<HTMLDivElement>(null);
  const wrap = useRef<HTMLDivElement>(null);
  const [path, setPath] = useState("");
  const [mode, setMode] = useState("CUT");
  const [activeObject, setActiveObject] = useState({});
  const [activeObjectText, setActiveObjectText] = useState({});
  const [undo, setUndo] = useState(false);
  const [redo, setRedo] = useState(false);
  const [loadImage, setLoadImage] = useState(false);

  useEffect(() => {
    if (!isEmpty(src)) {
      let xhr = new XMLHttpRequest();
      let imgSrc = src.data.imageUrl || src.data.fileUrl;
      xhr.open("GET", imgSrc, true);
      xhr.responseType = "blob";
      console.log("xhr", imgSrc);
      xhr.onload = function () {
        if (this.status === 200) {
          let blob = this.response;
          console.log(blob);
          //fileReader.readAsDataURL(blob);
          setEditorImage(false, blob);
        }
      };
      xhr.send();
    } else {
      const fileInput: any = file.current!.files;
      console.log(fileInput[0]);
      const fileSize = fileInput[0].size;
      const maxSize = 3 * 1024 * 1024;
      if (fileSize > maxSize) {
        setEditorImage(true, fileInput[0]);
      } else {
        setEditorImage(false, fileInput[0]);
      }
    }
  }, []);

  useEffect(() => {
    if (isEmpty(path) || isEmpty(editor)) {
      return;
    }
    editor.on({
      objectActivated: function (obj: any) {
        setActiveObject({ ...activeObject, id: obj.id, type: obj.type });
      },
      undoStackChanged: function (length: any) {
        if (length) {
          setUndo(true);
        } else {
          setUndo(false);
        }
      },
      redoStackChanged: function (length: any) {
        if (length) {
          setRedo(true);
        } else {
          setRedo(false);
        }
      },
    });

    editor
      .loadImageFromURL(path, "SampleImage")
      .then(function (result: any) {
        editor.clearUndoStack();
        editor.clearRedoStack();
        editor._clearHistory();
        editor._initHistory();
        setLoadImage(true);
      })
      .catch(() => {
        setLoadImage(true);
      });
  }, [path, editor]);

  useEffect(() => {
    if (!loadImage) {
      dispatch({ type: "LOADING_START" });
      console.log("loading start");
    } else {
      dispatch({ type: "LOADING_END" });
      console.log("loading end");
    }
  }, [loadImage]);

  const setEditorImage = async (compress: boolean, file: any) => {
    let url: any = "";
    if (compress) {
      url = await compressImage(file, 3);
    } else {
      url = file;
    }
    let image = new Image();
    const reader = new FileReader();
    // 이미지가 로드가 된 경우
    reader.onload = (e: any) => {
      image.src = e.target.result;
      var base64str = e.target.result.split("base64,")[1];
      var decoded = atob(base64str);
      console.log("size   : " + decoded.length / 1024 / 1024);
    };
    image.onload = () => {
      console.log(image.width + "   :  " + image.height);
      let long = 1100;
      let width = image.width;
      let height = image.height;
      if (width > height) {
        let ratio = long / width;
        width = long;
        height *= ratio;
      } else {
        let ratio = long / height;
        height = long;
        width *= ratio;
      }
      let canvas = document.createElement("canvas") as HTMLCanvasElement;
      let context = canvas.getContext("2d");
      let image1 = new Image();
      image1.onload = function () {
        canvas.width = width;
        canvas.height = height;
        context!.drawImage(image, 0, 0, width, height);
        let result = canvas.toDataURL("image/png");
        setEditor(
          new ImageEditor(editorDiv.current, {
            cssMaxWidth: editorDiv.current?.clientWidth, //document.documentElement.clientWidth,
            cssMaxHeight: editorDiv.current?.clientHeight, //document.documentElement.clientHeight,
            selectionStyle: {
              cornerSize: 20,
              rotatingPointOffset: 70,
            },
          })
        );
        setLoadImage(false);
        var base64str = result.split("base64,")[1];
        var decoded = atob(base64str);
        console.log(
          "size   : " + decoded.length / 1024 / 1024,
          width,
          height,
          canvas.width,
          canvas.height
        );
        setPath(result);
      };
      image1.src = image.src;
    };
    reader.readAsDataURL(url);
  };

  return (
    <>
      <EditorHeader
        handleClose={handleClose}
        returnUrl={returnUrl}
        mode={mode}
        setMode={setMode}
        editor={editor}
        setPath={setPath}
        setLoadImage={setLoadImage}
      />
      <div className="custon-editor" ref={wrap}>
        <Controller editor={editor} undo={undo} redo={redo} editorDiv={editorDiv} />
        <div ref={editorDiv} className="editor-div"></div>
        <Functions
          editor={editor}
          activeObject={activeObject}
          setActiveObject={setActiveObject}
          activeObjectText={activeObjectText}
          setActiveObjectText={setActiveObjectText}
          path={path}
          editorDiv={editorDiv}
          mode={mode}
          setMode={setMode}
          loadImage={loadImage}
          setLoadImage={setLoadImage}
        />
      </div>
    </>
  );
  //
};

const Controller = ({ undo, redo, editor, editorDiv }: ControllerProp) => {
  const [style, setStyle] = useState({});

  useEffect(() => {
    const editor = document.querySelector(".editor-div");
    if (editor) {
      let styles: any = {};
      styles.width = editor.clientWidth;
      styles.height = editor.clientHeight;
      setStyle({ ...styles });
    }
  }, []);

  const clickUndo = () => {
    if (undo) {
      editor.undo();
    }
  };

  const clickRedo = () => {
    if (redo) {
      editor.redo();
    }
  };

  return (
    <>
      <div className="custom-editor-controller">
        <div className="history">
          <div className="undo" onClick={clickUndo}>
            {undo && <img src={undoActive} />}
            {!undo && <img src={undoDisable} />}
          </div>
          <div className="redo" onClick={clickRedo}>
            {redo && <img src={redoActive} />}
            {!redo && <img src={redoDisable} />}
          </div>
        </div>
      </div>
    </>
  );
};

const Functions = ({
  editor,
  activeObject,
  activeObjectText,
  setActiveObject,
  setActiveObjectText,
  path,
  editorDiv,
  mode,
  setMode,
  loadImage,
  setLoadImage,
}: FunctionsProp) => {
  const [color, setColor] = useState("#000000");
  const [brush, setBrush] = useState(12);
  const [textColor, setTextColor] = useState("#000000");
  const [activeGrid, setActiveGrid] = useState("");
  const [multiple, setMultiple] = useState(1);
  const [mode1, setMode1] = useState("");

  useEffect(() => {
    /*let header = document.querySelector(".add-comunity-header") as HTMLDivElement;
        if(isEmpty(mode)){
            header.classList.remove("close");
            header.classList.add("open");
        }else{
            header.classList.remove("open");
            header.classList.add("close");
        }*/
    if (!loadImage) {
      return;
    }
    if (mode === "CUT") {
      editor.stopDrawingMode();
      editor.startDrawingMode("CROPPER");
      editor.setCropzoneRect(editor.getCanvasSize().width / editor.getCanvasSize().height);
    } else if (mode === "GRID") {
      editor.stopDrawingMode();
    } else if (mode === "DRAW") {
      editor.stopDrawingMode();
      editor.startDrawingMode("FREE_DRAWING");
      editor.setBrush({
        width: 12,
        color: color,
      });
    }
  }, [mode, loadImage]);

  const clickModeCut = () => {
    setMode("CUT");
    editor.stopDrawingMode();
    editor.startDrawingMode("CROPPER");
  };

  const clickModeDraw = () => {
    setMode("DRAW");
    if ("DRAW" === mode) {
      editor.stopDrawingMode();
    } else {
      editor.stopDrawingMode();
      editor.startDrawingMode("FREE_DRAWING");
      editor.setBrush({
        width: 12,
        color: color,
      });
    }
  };

  const clickModeText = () => {
    setMode("TEXT");
    if ("TEXT" === mode) {
      editor.stopDrawingMode();
    } else {
      /**/
      editor.stopDrawingMode();
      editor.startDrawingMode("TEXT");
      editor
        .addText("DoubleClick", {
          styles: {
            fontFamily: "Meidum",
            fontSize: sizeList[3].fontSize,
          },
          autofocus: true,
        })
        .then((objectProps: any) => {});
    }
  };

  const clickModeGrid = () => {
    setMode("GRID");
  };

  return (
    <>
      {mode === "GRID" && (
        <GridControll
          editor={editor}
          setMode={setMode}
          activeGrid={activeGrid}
          editorDiv={editorDiv}
          setActiveGrid={setActiveGrid}
          path={path}
          multiple={multiple}
          setMultiple={setMultiple}
          mode1={mode1}
          setMode1={setMode1}
          setLoadImage={setLoadImage}
        />
      )}
      {mode === "CUT" && <CutControll editor={editor} setMode={setMode} />}
      {mode === "DRAW" && (
        <>
          <DrawControll
            brush={brush}
            setBrush={setBrush}
            color={color}
            setColor={setColor}
            editor={editor}
            activeObject={activeObject}
            setActiveObject={setActiveObject}
            setActiveObjectText={setActiveObjectText}
            activeObjectText={activeObjectText}
            setMode1={setMode}
          />
        </>
      )}
      {mode === "TEXT" && (
        <>
          <TextControll
            color={textColor}
            setColor={setTextColor}
            editor={editor}
            activeObject={activeObjectText}
            setMode1={setMode}
          />
        </>
      )}
    </>
  );
};

/*
<div className="custon-editor-feature-wrap">
                <div className="custon-editor-feature">
                    <div className="btn" onClick={clickModeCut}><img src={cut}/>자르기</div>
                    <div className="btn" onClick={clickModeGrid}><img src={bodyScreen}/>바디스크린</div>
                    <div className="btn" onClick={clickModeDraw}><img src={draw}/>그리기</div>
                    <div className="btn" onClick={clickModeText}><img src={text}/>글쓰기</div>
                </div>
            </div>
*/

export const isUndefind = (value: any) => {
  return typeof value === "undefined";
};

export const getPoint = (e: any) => {
  const x =
    !isUndefind(e.changedTouches) && !isUndefind(e.changedTouches[0])
      ? e.changedTouches[0].pageX
      : e.pageX;
  const y =
    !isUndefind(e.changedTouches) && !isUndefind(e.changedTouches[0])
      ? e.changedTouches[0].pageY - 60
      : e.pageY - 60;
  return { x, y };
};
/*
const ImageEditer = () => {

    const canvas = useRef<HTMLCanvasElement>(null);
    const editor = useRef<HTMLDivElement>(null);
    const file = useRef<HTMLInputElement>(null);
    const [context, setContext] = useState<any>();
    const [brush, setBrush] = useState<number>(5);
    const width = useRef<number>(document.documentElement.clientWidth);
    const height = useRef<number>(document.documentElement.clientHeight - 172);
    const [maskData, setMaskData] = useState<Array<mask>>([]);
    const [mode, setMode] = useState("");
    const [outerSize, setOuterSize] = useState({
        width: 0,
        height: 0
    });

    useEffect(() => {
        setContext(canvas.current?.getContext('2d'));
        
    }, []);

    useEffect(() => {
        if(context){
            const image = new Image();
            image.src = center_empty;   
            image.onload = function() {
                const size = calcSize(image);  
                canvas.current!.width = size.width;
                canvas.current!.height = size.height;
                editor.current!.style.width = size.width+"px";
                editor.current!.style.height = size.height+"px";
                setOuterSize({...size});
                context.drawImage(image, 0, 0, size.width, size.height);
            };
        }
    }, [context])

    

    const changeMode = (s: string) => () => {
        setMode(s);
    }

    const save = () => {
        var newTab: any = window.open(); 
        var img: any = new Image(); 
        img.onload = function() { 
        newTab.document.body.append(img); 
        } 
        img.src = canvas.current?.toDataURL("image/png"); 
    
    }

    function radToDag(angle: number){
        return angle * Math.PI/180;
    }

    const add = () => {
        context.globalCompositeOperation = 'source-over';
        for(let i=0; i<maskData.length; i++){
            const data = maskData[i];
            if(data.image){
                const image = new Image();
                image.src = data.ref;
                image.onload = function() {
                    console.log(data.rotate)
                    if(data.rotate > 0){
                        context.save();
                        context.translate((data.x+data.width), (data.y+data.height));			//이미지의 생성점과 회전 기준점을 설정
                        context.rotate(radToDag(data.rotate));	//기준점을 기준으로 회전
                        context.drawImage(image, 0, 0, -data.width, data.height);		//기준점이 0,0이기 때문에 0,0으로 생성됨
                        context.restore();	
                    }else{
                        context.drawImage(image, data.x, data.y, data.width, data.height);		//기준점이 0,0이기 때문에 0,0으로 생성됨
                    }
                };
            }else{
                context.font = data.fontSize+"px "+data.fontFamily;
                context.fillStyle = data.color;
                var lines = data.ref.replace(/\r|\n/gi, "<br/>").split('<br/>');
                console.log(lines)
                for (var j = 0; j<lines.length; j++)
                    context.fillText(lines[j], data.x+15, (data.y + ((j+1)*data.lineHeight!)+7) );
            }
        }
        setMaskData([]);
    }

    const mask = () => {
        const fileInput: any = file.current!.files;
        const list = maskData;
        let image = new Image();
        if(fileInput[0]){
            const reader = new FileReader();
            // 이미지가 로드가 된 경우
            reader.onload = (e: any) => {
                console.log("e", e.target.result)
                image.src = e.target.result;
                image.onload = function() {
                    const size = calcSize(image);
                    list.push({x: 0, y: 0, ref: e.target.result, width: size.width, height: size.height, rotate: 0, image: true, active: false});
                    console.log("load", size, list)
                    setMaskData([...list]);
                };
            }
            // reader가 이미지 읽도록 하기
            reader.readAsDataURL(fileInput[0])
        }
    }

    const maskList = maskData.map((d: mask, i: number) => {
        return(
            <Mask index={i} data={d} editor={editor} maskData={maskData} setMaskData={setMaskData} key={i}  mode={mode} outerSize={outerSize}/>
        )
    });
    
    const maskText = () => {
        changeMode("mask")();
        const size = {width: 150, height: 20};
        maskData.push({x: 0, y: 0, ref: "", width: size.width, height: size.height, rotate: 0, image: false, fontSize: 20, fontFamily: "preBold", color: "#fff"});
        console.log("load", size, maskData)
        setMaskData([...maskData]);
    }

    const clickCapture = () => {
        add();
        setMode("capture")
    }

    return(
        <Fragment>
            <div className="imageEditor" ref={editor}>
                <canvas
                  ref={canvas}
                  width={width.current}
                  height={height.current}
                  style={{'touchAction': 'none', 'userSelect': 'none'}}></canvas>
                {maskList}
                <Drawing canvas={canvas} context={context} brush={brush} mode={mode}/>
                <Capture mode={mode}/>
            </div>
            <span className="" onClick={changeMode("draw")}>그리기 </span>
            <span className="" onClick={save}>저장 </span>
            <label className="" onClick = {changeMode("mask")}>
                <input type="file" onChange={mask} ref={file} accept="image/png, image/jpeg;capture=camera"/>마스크 
            </label>
            <span onClick={maskText}>마스크 텍스트</span>
            <span className="" onClick={add}> 합치기 </span>
            <span className="" onClick={() => {setBrush(brush-1)}}>줄이기 </span>
            <span className="" onClick={() => {setBrush(brush+1)}}>늘리기 </span>
            <span onClick={clickCapture}>잘라내기</span>
        </Fragment>
    )
}*/

export default ImageEditer;
